import { Info, InfoDark, isPwaMode, noop, useAppTheme } from '@capsicum/common';
import { GenericDrawer, Text } from '@capsicum/common-web';
import { useGenericAgreement } from '@capsicum/features/regulations/shared';
import styled from 'styled-components';

import type { WCPledgeRequirementModalProps } from '@capsicum/features/world-championship-pledge/shared';

export const WCPledgeRequirementModal = ({
	closeModal,
	onAgree,
	onDisagree,
	requirement,
	testID
}: WCPledgeRequirementModalProps) => {
	const { mode } = useAppTheme();

	const { acceptAgreement, agreeButtonText, cancelAgreement, disagreeButtonText, subtitle, title } =
		useGenericAgreement(requirement);

	return (
		<GenericDrawer
			buttonText={agreeButtonText}
			image={mode === 'dark' ? InfoDark : Info}
			isButtonFullWidth={!!isPwaMode()}
			isButtonOnRow={false}
			secondaryActionButtonText={disagreeButtonText}
			testID={`${testID}-disclaimer`}
			title={title}
			onButtonPress={() => {
				acceptAgreement({ close: closeModal, delay: 100, showConfirmModal: noop });
				onAgree?.();
			}}
			onSecondaryActionOnButtonPress={() => {
				cancelAgreement({ close: closeModal, delay: 100, showDeclineModal: noop });
				onDisagree?.();
			}}
		>
			<S.Description variant="text3">{subtitle}</S.Description>
		</GenericDrawer>
	);
};

namespace S {
	export const Description = styled(Text)`
		color: ${({ theme }) => theme.colors.text.main.enabled};
		text-align: center;
	`;
}
